import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useAuthContext } from '@isyc-react/auth/modules/context';
import React from 'react';
import { UserPictureLG } from "./user-picture-lg.component";
import { UserPictureSM } from "./user-picture-sm.component";
import "./user-picture.style.scss";
export let UserPictureSize = /*#__PURE__*/function (UserPictureSize) {
  UserPictureSize["BG"] = "BG";
  UserPictureSize["SM"] = "SM";
  return UserPictureSize;
}({});
export let PositionNameSM = /*#__PURE__*/function (PositionNameSM) {
  PositionNameSM["RIGHT"] = "RIGHT";
  PositionNameSM["LEFT"] = "LEFT";
  return PositionNameSM;
}({});
export const UserPictureComponent = props => {
  const {
    size = UserPictureSize.SM,
    positionName = PositionNameSM.RIGHT,
    text,
    image
  } = props;
  const {
    disableName = false
  } = text;
  const {
    user
  } = useAuthContext();
  const colorRand = React.useMemo(() => {
    const localColor = localStorage.getItem('user_color_badge');
    if (localColor) {
      return parseInt(localColor);
    } else {
      const randColor = Math.floor(Math.random() * 4) + 1;
      localStorage.setItem('user_color_badge', randColor.toString());
      return randColor;
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, user && user.person && /*#__PURE__*/React.createElement(React.Fragment, null, size === UserPictureSize.SM ? /*#__PURE__*/React.createElement(UserPictureSM, {
    positionName: positionName,
    image: _objectSpread({
      colorIndex: colorRand
    }, image),
    text: _objectSpread({
      disableName: disableName
    }, text)
  }) : /*#__PURE__*/React.createElement(UserPictureLG, {
    image: _objectSpread({
      colorIndex: colorRand
    }, image),
    text: _objectSpread({
      disableName: disableName
    }, text)
  })));
};